import axios from 'axios';

// Create axios instance - use relative URL so it goes through Apache proxy
const api = axios.create({
  baseURL: '/api/v1',
  timeout: 60000, // 60 seconds for regular requests
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Increase timeout for file uploads (multipart/form-data)
    if (config.headers['Content-Type'] === 'multipart/form-data') {
      config.timeout = 120000; // 2 minutes for file uploads
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Redirect to login
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
